import React from 'react';
import DropDownList from '../../../component/iconDropDown/iconDropDown';

const HardwareTitleIcon = () => {
    const common = { fill: 'none', stroke: 'currentColor', viewBox: '0 0 24 24' };
    return (
        <svg {...common} aria-hidden>
            <rect x="4" y="4" width="16" height="16" rx="2" strokeWidth="2" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 9h6v6H9z" />
            <path strokeLinecap="round" strokeWidth="2" d="M12 2v2M12 20v2M2 12h2M20 12h2" />
        </svg>
    );
};

const InfoIcon = () => (
    <span
      className="vc-hpb-info has-tooltip"
      data-tt-title="Policy binding"
      data-tt-desc="Links this vehicle preset to reusable hardware policy templates configured in the admin modules."
      aria-hidden
    >
        i
    </span>
);

const BindingRow = ({
    label,
    tooltipTitle,
    tooltipDesc,
    children,
}) => (
    <div className="vc-hpb-row">
        <div
          className="vc-hpb-lbl has-tooltip"
          data-tt-title={tooltipTitle}
          data-tt-desc={tooltipDesc}
        >
            {label}
            <InfoIcon />
        </div>
        <div className="vc-hpb-control">{children}</div>
    </div>
);

/**
 * Hardware policy bindings card (fuel / battery policy pickers).
 */
export const HardwarePolicyBindingsPanel = ({
    fuelPolicyOptions,
    selectedFuelPolicy,
    onFuelPolicyChange,
    batteryPolicyOptions,
    selectedBatteryPolicy,
    onBatteryPolicyChange,
}) => (
    <section className="vc-panel vc-panel-hpb">
        <div className="vc-panel-hdr">
            <div className="vc-panel-title">
                <HardwareTitleIcon />
                Hardware Policy Bindings
            </div>
        </div>
        <div className="vc-panel-body">
            <BindingRow
              label="Fuel Policy"
              tooltipTitle="Fuel policy"
              tooltipDesc="Reusable fuel tank profile from Fuel Configurator. All configured fuel policy names are listed here."
            >
                <div className="vc-dd-wrap">
                    <DropDownList
                      placeholder="Select policy"
                      selectedValue={selectedFuelPolicy}
                      setSelectedValue={onFuelPolicyChange}
                      options={fuelPolicyOptions}
                      width="100%"
                      maxWidth="100%"
                    />
                </div>
            </BindingRow>
            <BindingRow
              label="Battery Policy"
              tooltipTitle="Battery policy"
              tooltipDesc="Starter battery mapping profile from Battery Configurator. All configured battery policy names are listed here."
            >
                <div className="vc-dd-wrap">
                    <DropDownList
                      placeholder="Select policy"
                      selectedValue={selectedBatteryPolicy}
                      setSelectedValue={onBatteryPolicyChange}
                      options={batteryPolicyOptions}
                      width="100%"
                      maxWidth="100%"
                    />
                </div>
            </BindingRow>
        </div>
    </section>
);

export const HV_POLICY_ICE_OPTION = { value: 'ice', label: '— ICE asset' };
export const HV_POLICY_EV_OPTION = { value: 'ev', label: 'HV traction profile' };

export const buildHvPolicyOptions = (isDieselPreset) => (
    isDieselPreset
        ? [HV_POLICY_ICE_OPTION]
        : [HV_POLICY_EV_OPTION, HV_POLICY_ICE_OPTION]
);
